define('lq/events/actions/refreshCaptcha',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function RefreshCaptcha(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(RefreshCaptcha, EventAction);

    RefreshCaptcha.typeName = 'RefreshCaptcha';

    RefreshCaptcha.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    RefreshCaptcha.prototype.execute = function (continuation) {
        var captchaDrop = this.piping.dropFactory
            .findDropByName(this.eventData.captchaField);
        captchaDrop.refreshCaptcha();

        continuation();
    };
    
    return RefreshCaptcha;
});
